import React, { Component } from 'react'
import './_styles.scss'
import Utils from '../../../../../utils/Utils'

/**
 * GroupTitle
 * Displays the current active group label ("Grupo A", "Grupo B", …).
 *
 * Props:
 * label {string} 
 */
class GroupTitle extends Component {
  render () {
    const { label } = this.props
    if (!label) return null

    return (
      <p className='group-title'>
        {Utils.cutPlayerString(label, 34)}
      </p>
    )
  }
}

export default GroupTitle



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/Components/GroupTitle/index.jsx